/**
 * Auth Layout
 *
 * Minimal layout for authentication pages
 */

import { Link, Outlet } from "react-router-dom";

export function AuthLayout() {
  return (
    <div className="min-h-screen bg-[var(--mist)] flex flex-col">
      {/* Minimal header */}
      <header className="p-6">
        <Link to="/" className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-full bg-[var(--ink)] text-white flex items-center justify-center font-semibold">
            B
          </div>
          <div>
            <p className="font-semibold text-lg">Boat361</p>
            <p className="text-xs text-slate-500">Vessels Marketplace</p>
          </div>
        </Link>
      </header>

      {/* Auth content */}
      <main className="flex-1 flex items-center justify-center px-4">
        <Outlet />
      </main>
    </div>
  );
}
